// gatsby-browser.js
import "@fontsource/outfit/400.css"; // Regular weight
import "@fontsource/outfit/500.css"; // Medium weight
import "@fontsource/outfit/600.css"; // Semi-Bold weight
import "@fontsource/outfit/700.css"; // Bold weight

import "firebase/auth";
import "firebase/firestore";
import Modal from "react-modal";
import ReactDOM from "react-dom";

import wrapWithProvider from "./wrap-with-provider";
import browserHydrateFunction from "./src/utils/browser-hydrate-functions";
export const wrapRootElement = wrapWithProvider;

export const onClientEntry = () => {
  Modal.setAppElement("#___gatsby");
  
  // Patch ReactDOM.unmountComponentAtNode for React 18 compatibility
  // This fixes warnings from Gatsby's head-export-handler which uses the old API
  if (typeof window !== 'undefined' && ReactDOM && ReactDOM.unmountComponentAtNode) {
    const originalUnmount = ReactDOM.unmountComponentAtNode;
    ReactDOM.unmountComponentAtNode = function(container) {
      // If container has a root (from createRoot), use root.unmount() instead
      if (container && container._reactRootContainer && container._reactRootContainer.unmount) {
        container._reactRootContainer.unmount();
        delete container._reactRootContainer;
      } else {
        // Fallback to original for containers without our root
        originalUnmount.call(this, container);
      }
    };
  }
};

export const replaceHydrateFunction = browserHydrateFunction;
